import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function DemoSection() {
  return <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-700" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="max-w-3xl mx-auto text-center" data-id="element-15">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-16">
            Erleben Sie Legallama in einer 20-Minuten-Demo
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-17">
            Wir zeigen Ihnen live, wie ein kompletter verkehrsrechtlicher Fall
            in Sekunden automatisch durchläuft – von der Erstdatenerfassung bis
            zur fertigen Akte.
          </p>
          <p className="text-lg text-blue-100 mb-8" data-id="element-18">
            Überzeugen Sie sich selbst vom Unterschied.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-19">
            <a href="mailto:hello@legallama.de?subject=Ich%20wünsche%20eine%20Demo%20zu%20Legallama" className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors flex items-center justify-center gap-2" data-id="element-20">
              Kostenlose Live-Demo buchen
            </a>
            <button className="bg-blue-800 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-900 transition-colors flex items-center justify-center gap-2 border-2 border-white" data-id="element-21">
              <PlayCircleIcon className="w-6 h-6" data-id="element-22" />
              Ablauf eines Falles ansehen
            </button>
          </div>
        </div>
      </div>
    </section>;
}